// extracted by mini-css-extract-plugin
export var container = "_3e-1";
export var editor = "_3e-2";
export var resizable = "_3e-3";
export var wrapper = "_3e-0";